import { match } from "ts-pattern";
import { cn } from "../../../utils/class-names";
import { useDescriptionVariant } from "../../description/use-description-variant";
import { LINKS, Usd } from "@silo/types";
import { isNullable } from "effect/Predicate";
import { ExternalLink } from "./external-link";

interface DepositLiquidationPriceDescriptionProps {
  className?: string;
  liquidationPriceUsd: Usd | null;
}

export function DepositLiquidationPriceDescription({
  className,
  liquidationPriceUsd,
}: DepositLiquidationPriceDescriptionProps): JSX.Element {
  const descriptionVariant = useDescriptionVariant();

  const notApplicableClassName = match(descriptionVariant)
    .with("static", () => "text-white")
    .with("tooltip", () => "text-amber-300")
    .exhaustive();

  return (
    <div className={cn("flex flex-col items-start gap-5", className)}>
      <p>
        This is the simulated asset price at which the borrow position becomes
        insolvent (HF goes to 0%).
      </p>

      <p>
        If you have deposited two assets, the liquidation price for each asset
        is weighted to reflect its impact on the position.
      </p>

      {isNullable(liquidationPriceUsd) && (
        <p>
          <span className={`font-medium ${notApplicableClassName}`}>
            "--" (no value)
          </span>{" "}
          means the asset's weight of the total deposit position is
          insignificant such that even if the asset's value drops to $0, it will
          not cause liquidation.
        </p>
      )}

      <div>
        <ExternalLink href={LINKS.SILOPEDIA.LIQUIDATION_PRICE} />
      </div>
    </div>
  );
}
